// extracted by mini-css-extract-plugin
export default {"navBar":"styles_navBar__LaBaH"};